var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeatbackPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SeatbackPortal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.25,11.75 L14.25,14.25 L11.75,14.25 L11.75,11.75 L14.25,11.75 L14.25,11.75 Z M14.875,10.5 L11.125,10.5 C10.779822,10.5 10.5,10.779822 10.5,11.125 L10.5,14.875 C10.5,15.220178 10.779822,15.5 11.125,15.5 L14.875,15.5 C15.220178,15.5 15.5,15.220178 15.5,14.875 L15.5,11.125 C15.5,10.779822 15.220178,10.5 14.875,10.5 Z M14.25,5.5 L14.25,8 L11.75,8 L11.75,5.5 L14.25,5.5 L14.25,5.5 Z M14.875,4.25 L11.125,4.25 C10.779822,4.25 10.5,4.52982203 10.5,4.875 L10.5,8.625 C10.5,8.97017797 10.779822,9.25 11.125,9.25 L14.875,9.25 C15.220178,9.25 15.5,8.97017797 15.5,8.625 L15.5,4.875 C15.5,4.52982203 15.220178,4.25 14.875,4.25 Z M8,11.75 L8,14.25 L5.5,14.25 L5.5,11.75 L8,11.75 L8,11.75 Z M8.625,10.5 L4.875,10.5 C4.52982203,10.5 4.25,10.779822 4.25,11.125 L4.25,14.875 C4.25,15.220178 4.52982203,15.5 4.875,15.5 L8.625,15.5 C8.97017797,15.5 9.25,15.220178 9.25,14.875 L9.25,11.125 C9.25,10.779822 8.97017797,10.5 8.625,10.5 Z M8,1.75 L8,8 L1.75,8 L1.75,1.75 L8,1.75 L8,1.75 Z M8,0.5 L1.75,0.5 C1.05964406,0.5 0.5,1.05964406 0.5,1.75 L0.5,8 C0.5,8.69035594 1.05964406,9.25 1.75,9.25 L8,9.25 C8.69035594,9.25 9.25,8.69035594 9.25,8 L9.25,1.75 C9.25,1.05964406 8.69035594,0.5 8,0.5 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon-color",
    fill: "#194A74",
    xlinkHref: "#path-2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatbackPortal);
export default __webpack_public_path__ + "static/media/SeatbackPortal.7b8f97eb.svg";
export { ForwardRef as ReactComponent };